/** Prefill prompt + deep links for footer “Ask AI about Millet” buttons */

export const MILLET_SITE_URL = 'https://getmillet.com';

export const MILLET_ASK_AI_PROMPT = (
  'I\u2019m researching creator marketing solutions and want to understand how Millet '
  + 'can help me run influencer campaigns more efficiently. Summarize the key ways Millet '
  + 'supports creator recruitment, campaign management, content production, and performance '
  + `tracking based on their website: ${MILLET_SITE_URL}`
);

const encodedPrompt = encodeURIComponent(MILLET_ASK_AI_PROMPT);
const plusEncodedPrompt = encodedPrompt.replace(/%20/g, '+');

export const MILLET_ASK_AI_LINKS = [
  {
    id: 'chatgpt',
    name: 'ChatGPT',
    href: `https://chatgpt.com/?prompt=${encodedPrompt}`,
  },
  {
    id: 'claude',
    name: 'Claude',
    href: `https://claude.ai/new?q=${encodedPrompt}`,
  },
  {
    id: 'perplexity',
    name: 'Perplexity',
    href: `https://www.perplexity.ai/search/new?q=${encodedPrompt}`,
  },
  {
    id: 'grok',
    name: 'Grok',
    href: `https://x.com/i/grok?text=${plusEncodedPrompt}`,
  },
  {
    id: 'gemini',
    name: 'Gemini',
    href: `https://www.google.com/search?udm=50&aep=11&q=${plusEncodedPrompt}`,
  },
];
